__turbopack_context__.v({
  "commandCode": "yR19Fa_commandCode",
  "commandCopyButton": "yR19Fa_commandCopyButton",
  "commandHeader": "yR19Fa_commandHeader",
  "commandOsBadge": "yR19Fa_commandOsBadge",
  "commandOutput": "yR19Fa_commandOutput",
  "commandOutputCode": "yR19Fa_commandOutputCode",
  "commandWrapper": "yR19Fa_commandWrapper",
});
